import Axios from 'axios';

const api = Axios.create({
  baseURL: 'https://graph.microsoft.com/v1.0',
  headers: {
    Accept: 'application/json',
  },
});

api.interceptors.request.use(
  (request) => {
    const authToken = localStorage.getItem('msalAccessToken');
    if (authToken != null) {
      request.headers.Authorization = `Bearer ${authToken}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      return Promise.reject({ code: 401 });
    }

    return Promise.reject(error);
  }
);

export default api;
